<ng-container *ngIf="!sessions || sessions.length === 0">
  <span>Aucune session en cours</span>
</ng-container>

<ng-container *ngIf="sessions && sessions.length > 0">
  <span #anchor class="clickable" (click)="toggle()" [matBadge]="sessions?.length" matBadgeColor="warn">Sessions en cours</span>

  <kendo-popup #popup [anchor]="anchor" [anchorAlign]="anchorAlign" (anchorViewportLeave)="show = false" *ngIf="show">
    <div class="session-container">
      <span *ngFor="let session of sessions">{{ session.userName }}</span>
    </div>
  </kendo-popup>
</ng-container>

<button *ngIf="existsSessionForCurrentUser$|async" mat-icon-button (click)="releaseSession()" matTooltip="Terminer ma session" color="primary">
  <mat-icon>stop</mat-icon>
</button>

<button
  *ngIf="!(existsSessionForCurrentUser$|async) && sessions?.length === 0"
  mat-icon-button
  (click)="takeSession()"
  matTooltip="Démarrer ma session"
  color="primary"
>
  <mat-icon>play_arrow</mat-icon>
</button>

<button
  *ngIf="!(existsSessionForCurrentUser$|async) && sessions?.length > 0"
  mat-icon-button
  (click)="forceTakeSession()"
  matTooltip="Forcer la prise de session"
  color="warn"
>
  <mat-icon>not_started</mat-icon>
</button>
